var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.sideModal ? 'side-modal' : 'modal',"appear":"appear"}},[(_vm.show)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }if (!_vm.timer) {
        _vm.closeModal();
      }}}},[_c('div',{class:_vm.sideModal ? 'side-modal' : 'modal'},[(_vm.timer)?_c('div',{staticClass:"modal-timer",style:({
          width: (_vm.timerWidth + "%"),
          backgroundColor: ("hsl(" + (110 - _vm.timerWidth) + ", 82%, 39%)"),
        })}):_vm._e(),_vm._t("default",function(){return [_vm._v("Default content")]})],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }